import api from '../index';

export const getCourses = async () => {
  const response = await api.get('/courses');
  return response.data;
};

export const createCourse = async (course) => {
  const response = await api.post('/courses', course);
  return response.data;
};

export const getTeacherCourses = async (teacherId) => {
  const response = await api.get(`/teachers/${teacherId}/courses`);
  return response.data;
};

export const getTeacherCourse = async (courseId) => {
  const response = await api.get(`/teachers/courses/${courseId}`);
  return response.data;
};

export const getTeacherCourseDetails = async (courseId) => {
  const response = await api.get(`/teachers/courses/${courseId}/details`);
  return response.data;
};

export const createNewTopic = async (topic) => {
  const response = await api.post('/topics', topic);
  return response.data;
};

export const getLessonStructures = async (course_id) => {
  const response = await api.post('/courses/lesson-structures', { course_id: course_id });
  return response.data;
};

export const getTeachingPlanCreationData = async (course_id) => { 
  const response = await api.get(`/courses/${course_id}/teaching-plan-creation-data`);
  return response.data;
};

export const createTeachingPlan = async (teachingPlan) => { 
  const response = await api.post('courses/teaching-plan', teachingPlan);
  return response.data;
};






